import { render } from "./ChallengeResult.vue?vue&type=template&id=feae503a&scoped=true"
import script from "./ChallengeResult.vue?vue&type=script&lang=js"
export * from "./ChallengeResult.vue?vue&type=script&lang=js"

import "./ChallengeResult.vue?vue&type=style&index=0&id=feae503a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feae503a"]])

export default __exports__